module.exports = __webpack_public_path__ + "static/media/3-nastolnye.77bcf734.jpg";